export default () => ({
  generalAttributes: {
    display: 'flex',
    flexDirection: 'column',
  },
  section: {
    padding: '10px',
  },
  subheading: {
    color: '#7C7C80',
    fontSize: '18px',
    fontWeight: '500',
    textTransform: 'uppercase',
    margin: '10px 0',
  },
  sectionRow: {
    display: 'flex',
    alignItems: 'center',
  },
  formLabel: {
    flex: 0.5,
    marginRight: 10,
  },
});
